module.exports = __webpack_public_path__ + "img/car_rent_banner.37c6df3f.jpg";